import apis from "../api"
import fileToBase64 from "./fileToBase64"
import S3 from "react-aws-s3";


export default async function uploadFileS3(entity, client, file, directory, name, extension, headers) {
    /*Función encargada de cargar el logo de la empresa al servidor de imágenes*/
    // const config = {
    //     bucketName: process.env.REACT_APP_BUCKET_NAME,
    //     region: process.env.REACT_APP_REGION,
    //     dirName: client + '/' + directory,
    //     accessKeyId: process.env.REACT_APP_ACCESS_ID,
    //     secretAccessKey: process.env.REACT_APP_ACCESS_KEY,
    // };
    // const ReactS3Client = new S3(config);

    let url = ""
    // let newFileName = name + '.' + extension
    // try {
    //     await ReactS3Client.uploadFile(file, newFileName).then(res => {
    //         url = res.location
    //         console.log(res.location)
    //     })
    // }
    // catch (err) {
    //     console.log(err)
    //     // toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err, sticky: true });
    // }

    let base64 = ""
    await fileToBase64(file).then(res => {
        base64 = res
    })
    let payload = {
        BUCKET: process.env.REACT_APP_BUCKET_NAME,
        PARAMS: [
            {
                PARAM_1: entity,
                PARAM_2: client,
                PARAM_3: directory,
                PARAM_4: name,
                PARAM_5: extension,
                PARAM_6: base64
            }
        ]
    }
    await apis.postFileS3(payload, headers).then(resp => {
        url = resp.data.IMAGES
        console.log(url)
        // url = url[0]
    })

    return url
}